<template>
    <div class="main-container">
        <h2 class="main-title bottom-row">Third party scripts management</h2>
        <Loader v-if="isScriptsLoadInProgress"></Loader>
        <div v-else class="main-form">
            <div class="form">
                <div class="form__row">
                    <div>
                        <label class="form__label" v-if="this.selectedArena.config.scripts.public && this.selectedArena.config.scripts.public.length > 0">
                            Arena has scripts:</label>
                        <div v-for="script in this.selectedArena.config.scripts.public" :key="script.name" >
                            <a :value="script.name" @click="chooseScriptForm(script)" v-text="script.name" style="cursor: pointer;font-size: x-large"></a>
                        </div>
                        <v-checkbox
                          v-model="selectedArena.config.scripts.isActive"
                          label="All scripts are activated"
                          @click="changedCheckboxValue"
                          class="mx-2"
                        />
                    </div>
                </div>
                <div v-if="this.needSaveChanges" class="form__row">
                    <div style="text-align: right" >
                        <v-btn v-if="$checkRoles(['Administrator'])"
                               outlined color="red" large
                               @click="saveAllChanges()">
                            <Loader v-if="isScriptsLoadInProgress"></Loader>
                            <span v-else>Save All Changes</span>
                        </v-btn>
                    </div>
                </div>
                <div class="top-row">
                    <div class="form__input-box form__input-box--small">
                        <label class="form__label">Select a script for adding to arena:
                        <label>
                            <v-select outlined
                                      dense
                                      v-model="selectedScript"
                                      :items="allScripts.public"
                                      item-text="name"
                                      return-object>
                            </v-select>
                        </label>
                        </label>
                    </div>
                    <div class="form__row" v-if="this.selectedScript">
                        <div class="form__row">
                            <div class="bordered-panel">
                                <div class="inline-text-container">
                                    <div style="padding-top: 5px"><b>Name:</b> {{this.selectedScript.name}}</div>
                                    <div style="padding-top: 5px"><b>Description:</b> {{this.selectedScript.description}}</div>
                                    <div style="padding-top: 5px" v-if="this.selectedScript.vars.length > 0"><b>Variables:</b></div>
                                    <div class="form__input-box" >
                                        <div style="white-space: nowrap" v-for="vr in this.selectedScript.vars" :key="vr">
                                            <div style="width:100px;white-space: nowrap">{{vr}}</div><div><input type="text" class="form__input" name="vr" :placeholder="vr" :ref="vr" :value="getParamValue(vr)"></div>
                                        </div>
                                        <div style="white-space: nowrap">
                                            <div class="btns-row--bottom" style="padding-top: 10px;">
                                                <v-btn v-if="$checkRoles(['Administrator'])"
                                                       outlined color="indigo"
                                                        @click="saveScript()">
                                                    <Loader v-if="isScriptsLoadInProgress"></Loader>
                                                    <span v-else>Apply script changes to the arena</span>
                                                </v-btn>
                                            </div>
                                            <div class="btns-row--bottom" style="padding-top: 10px" v-if="isScriptExit(this.selectedScript.key)">
                                                <v-btn v-if="$checkRoles(['Administrator'])"
                                                       outlined color="indigo"
                                                        @click="removeScript()">
                                                    <Loader v-if="isScriptsLoadInProgress"></Loader>
                                                    <span v-else>Remove script from the arena</span>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <InfoModal
                v-if="scriptIsSaved"
                :msg="infoModalMessage"
                :onCloseModal="closeInfoModal"
        ></InfoModal>
    </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'
  import config from '../../../config'

  export default {
    components: {Loader, InfoModal},
    name: 'ScriptEditForm',
    props: ['selectedArena'],
    data () {
      return {
        allScripts: [],
        scriptIsSaved: false, // arena edited success flag
        isScriptsLoadInProgress: false,
        selectedScript: undefined,
        needSaveChanges: false,
        infoModalMessage: ''
      }
    },
    created: function () {
      this.getAllPublicScripts()
    },
    watch: {
      selectedArena: function (newValue, oldValue) {
        if (newValue) {
          this.getAllPublicScripts()
          this.needSaveChanges = false
        }
      }
    },
    computed: {

    },
    methods: {
      getAllPublicScripts () {
        this.isScriptsLoadInProgress = true
        let scriptsPromise = this.$http.get(`${config.apiUrl}/thirdpartyscripts/list`)
        Promise.all([scriptsPromise])
          .then(([scriptsResponse]) => {
            this.allScripts = scriptsResponse.body
            this.isScriptsLoadInProgress = false
          }, error => {
            console.log(error)
            this.isScriptsLoadInProgress = false
          })
      },
      scriptsSelectOnChange () {
      },
      getParamValue (param) {
        let result = ''
        this.selectedArena.config.scripts.public.forEach((script) => {
          if (script.name === this.selectedScript.key) {
            script.vars.forEach((variable) => {
              if (variable.key === param) {
                result = variable.value
              }
            })
          }
        })
        return result
      },
      isScriptExit (name) {
        let exist = false
        this.selectedArena.config.scripts.public.forEach((script) => {
          if (script.name === name) {
            exist = true
          }
        })
        return exist
      },
      saveScript: function () {
        this.needSaveChanges = true
        let scriptExist = false
        let keyValueVariables = []
        this.selectedScript.vars.forEach((paramName) => {
          keyValueVariables.push({key: paramName, value: this.$refs[paramName][0].value})
        })
        this.selectedArena.config.scripts.public.forEach((script) => {
          if (script.name === this.selectedScript.key) {
            scriptExist = true
            script.vars = keyValueVariables
          }
        })
        if (!scriptExist) {
          this.selectedArena.config.scripts.public.push({
            name: this.selectedScript.key,
            vars: keyValueVariables
          })
        }
        this.showInfoModal('Script has been applied to arena, if you finished changes do not forget to press save all changes button!')
        this.selectedScript = undefined
      },
      removeScript: function () {
        debugger
        this.needSaveChanges = true
        let index
        for (let i = 0; i < this.selectedArena.config.scripts.public.length; i++) {
          if (this.selectedArena.config.scripts.public[i].name === this.selectedScript.key) {
            index = i
          }
        }
        if (index >= 0) {
          this.$delete(this.selectedArena.config.scripts.public, index)
          this.showInfoModal('Script has been removed from arena, if you finished changes do not forget to press save all changes button!')
          this.selectedScript = undefined
        }
      },
      saveAllChanges: function () {
        const url = `${config.apiUrl}/thirdpartyscripts/scriptsupdate/?arenaDomain=${this.selectedArena.domain.replace('www.', '')}`
        const headers = {
          headers: {'Content-Type': 'application/json'}
        }
        this.$http.post(url, this.selectedArena.config.scripts, headers)
          .then(response => {
            this.showInfoModal('All changes are saved.')
            this.needSaveChanges = false
          }, error => {
            console.log(error)
          })
      },
      chooseScriptForm: function (scr) {
        this.allScripts.public.forEach((script) => {
          if (scr.name === script.key) {
            this.selectedScript = script
          }
        })
      },
      changedCheckboxValue: function () {
        this.needSaveChanges = true
      },
      closeInfoModal: function () {
        this.scriptIsSaved = false
      },
      showInfoModal: function (message) {
        this.infoModalMessage = message
        this.scriptIsSaved = true
      }
    }
  }
</script>

<style scoped lang="scss" src="./3rdPartyScriptsPage.scss"></style>
